import(/* webpackMode: "eager", webpackExports: ["AboutLodging"] */ "/app/app/[lang]/(public)/(home)/_components/AboutSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Ad"] */ "/app/app/components/atoms/ad.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Avatar"] */ "/app/app/components/atoms/avatar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SLinkButton"] */ "/app/app/components/atoms/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StyledDescription"] */ "/app/app/components/atoms/containers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MapBox"] */ "/app/app/components/atoms/mapbox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MediaGallery"] */ "/app/app/components/molecules/gallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContentLayout","AsideLayout"] */ "/app/app/components/molecules/layouts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BookingViews"] */ "/app/app/components/organisms/lodgings/bookings_views.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CommentForm"] */ "/app/app/components/organisms/messaging/comment.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["Skeleton"] */ "/app/node_modules/primereact/skeleton/skeleton.esm.js");
